const contractList = {
    path: 'contractList',
    component: resolve => require(['@/pages/admin/storage_audit/contractList.vue'], resolve),
}

export default contractList